const VARIANT_DEFAULT = "default";
const VARIANT_BUTTON_GROUP = "buttonGroup";

const TABLIST_VARIANTS = [VARIANT_DEFAULT, VARIANT_BUTTON_GROUP];

export { VARIANT_DEFAULT, VARIANT_BUTTON_GROUP, TABLIST_VARIANTS };
